var path = 'src/app/auth/forgot-username.html';
var html = "<div page-wrapper> <h1 class=page-header>Forgot Username</h1> <form class=\"form-container form-horizontal\" submit-if-valid=submit()> <div frm-field frm-group> <div frm-label>Registered Email</div> <div frm-control> <div frm-text-field model=data.email required=true></div> <div frm-errors errors=errors.email></div> </div> </div> <div frm-buttons> <span submit-button>Submit</span> </div> </form> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/forgot-username.html
 ** module id = 34
 ** module chunks = 0
 **/